import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    title: 'Complete your account setup',
  },
  fr: {
    title: 'Terminez la configuration de votre compte',
  },
});

export default locales;
